/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Apr_TInputs */

const en_mk_tut_apr_t = /** @type {(inputs: Mk_Tut_Apr_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approvals: the fence before an agent acts outward`)
};

const id_mk_tut_apr_t = /** @type {(inputs: Mk_Tut_Apr_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approval: pagar sebelum agen bertindak keluar`)
};

/**
* | output |
* | --- |
* | "Approvals: the fence before an agent acts outward" |
*
* @param {Mk_Tut_Apr_TInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_apr_t = /** @type {((inputs?: Mk_Tut_Apr_TInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Apr_TInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_apr_t(inputs)
	return en_mk_tut_apr_t(inputs)
});